<template>
  <div>
    <a-card :bordered="false">
      <div class="ri-header">
        <span class="ri-title">{{ reportName }} - 数据项</span>
        <div class="float-right">
          <a-button style="margin-right: 8px;" @click="goBack">返回</a-button>
          <a-button type="primary" icon="plus" @click="handleAdd()">添加项目</a-button>
        </div>
      </div>
      <a-table
        bordered
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="rows"
        :pagination="false"
        :loading="loading"
        :scroll="tableScroll">
        <span slot="action" slot-scope="text, record">
          <template v-if="canOperate(record)">
            <a @click="handleAddChild(record)">添加子级</a>
            <a-divider type="vertical" />
            <a @click="handleEdit(record)">编辑</a>
            <template v-if="record.is_group !== '1'">
              <a-divider type="vertical" />
              <a @click="openFormula(record)">公式</a>
            </template>
            <a-divider type="vertical" />
            <a @click="handleDelete(record)">删除</a>
          </template>
          <span v-else>-</span>
        </span>
        <span slot="name" slot-scope="text, record" :style="{ display: 'inline-block', paddingLeft: ((record.level || 0) * 15 + 8) + 'px', fontWeight: record.bold === '1' ? 600 : 400 }">{{ record.item_name }}</span>
        <span slot="source" slot-scope="text, record">{{ sourceText(record) }}</span>
      </a-table>
    </a-card>

    <!-- 编辑项目 Modal -->
    <a-modal
      :title="itemForm.id ? '编辑项目' : '添加项目'"
      :visible="itemVisible"
      :confirmLoading="itemSaving"
      :maskClosable="false"
      okText="保存"
      cancelText="取消"
      width="640px"
      @ok="saveItem"
      @cancel="itemVisible = false">
      <a-form>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="项目名称" required>
          <a-input v-model="itemForm.itemName" placeholder="请输入项目名称" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="归类项">
          <a-checkbox v-model="itemForm.isGroup" @change="onGroupChange">归类项（纯标题行，不取数）</a-checkbox>
          <div v-if="itemForm.isGroup" style="color: #999; font-size: 12px;">归类项不需要设置行号和公式</div>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上级项目">
          <a-select v-model="itemForm.parentId" placeholder="无（作为顶级项目）" allowClear>
            <a-select-option v-for="p in parentOptions" :key="p.id" :value="p.id">
              <span :style="{ display: 'inline-block', paddingLeft: ((p.level || 0) * 15) + 'px' }">{{ p.item_name }}</span>
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="行次">
          <a-input-number v-model="itemForm.rowNo" :min="1" style="width: 100%;" :disabled="itemForm.isGroup" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="取数来源">
          <a-radio-group v-model="itemForm.sourceType" :disabled="itemForm.isGroup">
            <a-radio value="outer">表外公式</a-radio>
            <a-radio value="inner">表内公式</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="!itemForm.isGroup && itemForm.sourceType === 'inner'" :labelCol="labelCol" :wrapperCol="wrapperCol" label="表内公式" required>
          <a-input v-model="itemForm.innerFormula" placeholder="行次加减式，如 1-2-3+5" />
        </a-form-item>
        <a-form-item v-if="routeType === 'balance'" :labelCol="labelCol" :wrapperCol="wrapperCol" label="类别">
          <a-select v-model="itemForm.category" placeholder="请选择类别" allowClear :disabled="itemForm.isGroup">
            <a-select-option value="资产">资产</a-select-option>
            <a-select-option value="负债">负债</a-select-option>
            <a-select-option value="所有者权益">所有者权益</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="名称加粗">
          <a-checkbox v-model="itemForm.bold" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="是否折叠">
          <a-checkbox v-model="itemForm.folded" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="显示位置">
          <a-input v-model="itemForm.displayPos" placeholder="如：左 / 右" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="排序" required>
          <a-input-number v-model="itemForm.sort" :min="0" style="width: 100%;" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 编辑公式 Modal -->
    <a-modal
      :title="'编辑公式 - ' + (formulaItem ? formulaItem.item_name : '')"
      :visible="formulaVisible"
      :maskClosable="false"
      :footer="null"
      width="720px"
      @cancel="formulaVisible = false">
      <a-spin :spinning="formulaLoading">
        <!-- 表内公式模式：行次引用表达式 -->
        <template v-if="formulaItem && formulaItem.source_type === 'inner'">
          <div style="margin-bottom: 8px; color: #999; font-size: 12px;">可用行次：{{ availableRowNos }}</div>
          <a-input v-model="innerFormulaValue" placeholder="行次加减式，如 1-2-3+5" />
          <div style="text-align: right; margin-top: 12px;">
            <a-button style="margin-right: 8px;" @click="formulaVisible = false">取消</a-button>
            <a-button type="primary" :loading="formulaSaving" @click="saveInnerFormula">保存</a-button>
          </div>
        </template>
        <!-- 表外公式模式：科目 ± 组合 -->
        <template v-else-if="formulaItem">
          <div style="display: flex; align-items: center; margin-bottom: 12px;">
            <a-select
              v-model="newFormula.subjectCode"
              show-search
              placeholder="选择科目"
              style="width: 280px;"
              :disabled="newFormula.calcRule === '损益净额合计'"
              :filterOption="filterSubjectOption">
              <a-select-option v-for="o in subjectOptions" :key="o.code" :value="o.code">{{ o.label }}</a-select-option>
            </a-select>
            <a-select v-model="newFormula.operator" style="width: 80px; margin-left: 8px;">
              <a-select-option value="+">+</a-select-option>
              <a-select-option value="-">-</a-select-option>
            </a-select>
            <span v-if="calcRules.length === 1" style="margin-left: 12px;">取数规则：{{ calcRules[0] }}</span>
            <a-select v-else v-model="newFormula.calcRule" style="width: 150px; margin-left: 8px;">
              <a-select-option v-for="r in calcRules" :key="r" :value="r">{{ r }}</a-select-option>
            </a-select>
            <a-button type="primary" style="margin-left: 12px;" @click="addFormulaRow">添加</a-button>
          </div>
          <a-table
            bordered
            size="middle"
            rowKey="key"
            :columns="formulaColumns"
            :dataSource="formulaRows"
            :pagination="false"
            :loading="formulaLoading">
            <span slot="subject" slot-scope="text, record">{{ subjectDisplay(record.subject_code, record.calc_rule) }}</span>
            <span slot="fAction" slot-scope="text, record" style="display: block;">
              <a @click="removeFormulaRow(record)">删除</a>
            </span>
          </a-table>
          <div style="text-align: right; margin-top: 12px;">
            <a-button style="margin-right: 8px;" @click="formulaVisible = false">取消</a-button>
            <a-button type="primary" :loading="formulaSaving" @click="saveFormulas">保存</a-button>
          </div>
        </template>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { accountSetCurrent, reportItemTree, reportItemSave, reportItemDelete, reportFormulaList, reportFormulaSave, reportFormulaDelete, subjectLeafList, cashFlowCandidates } from './api'
export default {
  name: 'ReportItemList',
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      accountSetId: null,
      loading: false,
      rows: [],
      tableScroll: { x: 'max-content', y: 400 },
      canEditTemplate: false,
      // 编辑项目
      itemVisible: false,
      itemSaving: false,
      itemForm: { id: null, itemName: '', isGroup: false, parentId: undefined, rowNo: undefined, sourceType: 'outer', innerFormula: '', category: undefined, bold: false, folded: false, displayPos: '', sort: undefined },
      // 编辑公式
      formulaVisible: false,
      formulaLoading: false,
      formulaSaving: false,
      formulaItem: null,
      formulaRows: [],
      formulaOriginal: [],
      formulaNewSeq: 0,
      formulaColumns: [
        { title: '科目', dataIndex: 'subject_code', scopedSlots: { customRender: 'subject' } },
        { title: '运算符号', dataIndex: 'operator', width: 90, align: 'center' },
        { title: '取数规则', dataIndex: 'calc_rule', width: 150 },
        { title: '操作', dataIndex: 'fAction', width: 70, align: 'center', scopedSlots: { customRender: 'fAction' } }
      ],
      innerFormulaValue: '',
      newFormula: { subjectCode: undefined, operator: '+', calcRule: '' },
      subjectOptions: [],
      subjectNameMap: {}
    }
  },
  computed: {
    /** 报表类型：query.type 优先（cashflow_supp 复用 cashflow 菜单路由），否则取路径末段 */
    routeType() {
      const q = this.$route.query.type
      if (q) return String(q)
      const seg = (this.$route.path || '').split('/').filter(Boolean).pop()
      return seg || 'profit'
    },
    reportName() {
      const names = { profit: '利润表', balance: '资产负债表', cashflow: '现金流量表', cashflow_supp: '现金流量表补充资料' }
      return names[this.routeType] || '报表'
    },
    /** 取数规则白名单（与后端按报表类型校验一致） */
    calcRules() {
      const map = {
        profit: ['净发生额'],
        balance: ['期末余额'],
        cashflow: ['现金流项目发生额'],
        cashflow_supp: ['净发生额', '余额变动', '损益净额合计']
      }
      return map[this.routeType] || []
    },
    columns() {
      const cols = [
        { title: '操作', dataIndex: 'action', width: 230, align: 'center', scopedSlots: { customRender: 'action' } },
        { title: '名称', dataIndex: 'item_name', scopedSlots: { customRender: 'name' } },
        { title: '行次', dataIndex: 'row_no', width: 70, align: 'center' },
        { title: '取数来源', dataIndex: 'source_type', width: 110, align: 'center', scopedSlots: { customRender: 'source' } }
      ]
      if (this.routeType === 'balance') {
        cols.push({ title: '类别', dataIndex: 'category', width: 100, align: 'center' })
      }
      cols.push({ title: '显示位置', dataIndex: 'display_pos', width: 90, align: 'center', customRender: (t) => t || '—' })
      return cols
    },
    /** 上级项目候选：编辑时排除自身及其子孙（防父级成环） */
    parentOptions() {
      const rows = this.rows
      const editId = this.itemForm.id
      if (!editId) return rows
      const blocked = {}
      blocked[editId] = true
      let grew = true
      while (grew) {
        grew = false
        rows.forEach((r) => {
          if (r.parentId != null && blocked[r.parentId] && !blocked[r.id]) { blocked[r.id] = true; grew = true }
        })
      }
      return rows.filter((r) => !blocked[r.id])
    },
    nextSort() {
      return this.rows.reduce((mx, r) => Math.max(mx, Number(r.sort || 0)), 0) + 10
    },
    /** 表内公式模式：本报表可用行次参考（排除自身） */
    availableRowNos() {
      const selfId = this.formulaItem ? this.formulaItem.id : null
      const nos = this.rows.filter((r) => r.row_no != null && r.id !== selfId).map((r) => r.row_no)
      return nos.length ? nos.join('、') : '无'
    }
  },
  watch: {
    /** 同组件不同报表间切换（含 query.type 变化）时重载；keep-alive 后台态（路由已离开本页）不发任何请求 */
    routeType() {
      const path = this.$route.path || ''
      if (path.indexOf('/plugin/gledger/reportItem/') !== 0) return
      const valid = ['profit', 'balance', 'cashflow', 'cashflow_supp']
      if (valid.indexOf(this.routeType) === -1) return
      this.subjectOptions = []
      this.subjectNameMap = {}
      this.itemVisible = false
      this.formulaVisible = false
      this.loadTree()
    }
  },
  created() { this.loadCurrent() },
  mounted() {
    this.$nextTick(() => {
      let head = 0
      const header = this.$el.querySelector('.ri-header')
      if (header) head += header.offsetHeight + 12
      this.tableScroll.y = Math.max(300, window.innerHeight - head - 260)
    })
  },
  methods: {
    loadCurrent() {
      accountSetCurrent({}).then((res) => {
        if (res && res.success && res.data && res.data.id) {
          this.accountSetId = res.data.id
          this.loadTree()
        } else { this.$message.warning('尚未建账或未设当前账套') }
      })
    },
    /** 数据项平铺树：客户端补算 level（缩进用，parentId 链上溯，防环）；非法报表类型直接返回 */
    loadTree() {
      if (!this.accountSetId) return
      const valid = ['profit', 'balance', 'cashflow', 'cashflow_supp']
      if (valid.indexOf(this.routeType) === -1) return
      this.loading = true
      reportItemTree({ reportType: this.routeType, accountSetId: this.accountSetId }).then((res) => {
        if (res && res.success && res.data) {
          this.canEditTemplate = !!res.data.canEditTemplate
          this.rows = this.withLevel(res.data.rows || [])
        } else {
          this.$message.warning((res && res.message) || '查询失败')
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    withLevel(rows) {
      const byId = {}
      rows.forEach((r) => { byId[r.id] = r })
      rows.forEach((r) => {
        let lv = 0
        const seen = {}
        let cur = r
        while (cur && cur.parentId != null) {
          if (seen[cur.id]) break
          seen[cur.id] = true
          const p = byId[cur.parentId]
          if (!p) break
          lv++
          cur = p
        }
        r.level = lv
      })
      return rows
    },
    /** 模板行（account_set_id=0）仅超管可操作 */
    canOperate(record) {
      return !(Number(record.account_set_id) === 0 && !this.canEditTemplate)
    },
    sourceText(r) {
      if (r.is_group === '1') return '归类项'
      if (r.source_type === 'outer') return '表外公式'
      if (r.source_type === 'inner') return '表内公式'
      return '—'
    },
    goBack() { this.$router.back() },
    // ==================== 编辑项目 ====================
    handleAdd(parent) {
      this.itemForm = {
        id: null, itemName: '', isGroup: false,
        parentId: parent ? parent.id : undefined,
        rowNo: undefined, sourceType: 'outer', innerFormula: '', category: undefined,
        bold: false, folded: false, displayPos: '', sort: this.nextSort
      }
      this.itemVisible = true
    },
    handleAddChild(record) { this.handleAdd(record) },
    handleEdit(record) {
      this.itemForm = {
        id: record.id,
        itemName: record.item_name || '',
        isGroup: record.is_group === '1',
        parentId: record.parentId == null ? undefined : record.parentId,
        rowNo: record.row_no == null ? undefined : Number(record.row_no),
        sourceType: record.source_type || 'outer',
        innerFormula: record.inner_formula || '',
        category: record.category || undefined,
        bold: record.bold === '1',
        folded: record.folded === '1',
        displayPos: record.display_pos || '',
        sort: record.sort == null ? this.nextSort : Number(record.sort)
      }
      this.itemVisible = true
    },
    /** 勾选归类项：禁用并清空行次/取数来源/表内公式/类别 */
    onGroupChange(e) {
      const checked = e.target.checked
      this.itemForm.isGroup = checked
      if (checked) {
        this.itemForm.rowNo = undefined
        this.itemForm.sourceType = null
        this.itemForm.innerFormula = ''
        this.itemForm.category = undefined
      } else if (!this.itemForm.sourceType) {
        this.itemForm.sourceType = 'outer'
      }
    },
    saveItem() {
      const f = this.itemForm
      if (!f.itemName || !f.itemName.trim()) { this.$message.warning('请输入项目名称'); return }
      if (f.sort === null || f.sort === undefined) { this.$message.warning('请输入排序'); return }
      const isGroup = f.isGroup ? '1' : '0'
      let sourceType = isGroup === '1' ? null : (f.sourceType || null)
      let rowNo = (isGroup === '1' || f.rowNo === undefined || f.rowNo === null) ? null : String(f.rowNo)
      let innerFormula = null
      if (sourceType === 'inner') {
        const expr = (f.innerFormula || '').trim()
        if (!/^\d+([+-]\d+)*$/.test(expr)) {
          this.$message.warning('表内公式格式不正确（应为行次加减式，如 1-2-3+5）')
          return
        }
        innerFormula = expr
      }
      this.itemSaving = true
      reportItemSave({
        id: f.id || undefined,
        accountSetId: this.accountSetId,
        reportType: this.routeType,
        itemName: f.itemName.trim(),
        parentId: f.parentId || null,
        rowNo: rowNo,
        isGroup: isGroup,
        sourceType: sourceType,
        innerFormula: innerFormula,
        category: (isGroup !== '1' && this.routeType === 'balance') ? (f.category || null) : null,
        bold: f.bold ? '1' : '0',
        folded: f.folded ? '1' : '0',
        displayPos: f.displayPos || null,
        sort: f.sort
      }).then((res) => {
        if (res && res.success) {
          this.$message.success('保存成功')
          this.itemVisible = false
          this.loadTree()
        } else {
          this.$message.warning((res && res.message) || '保存失败')
        }
        this.itemSaving = false
      }).catch(() => { this.itemSaving = false })
    },
    handleDelete(record) {
      this.$confirm({
        title: '删除确认',
        content: '删除「' + record.item_name + '」将同时删除其子级数据项与取数公式，确定删除？',
        onOk: () => {
          reportItemDelete({ id: record.id }).then((res) => {
            if (res && res.success) {
              this.$message.success('删除成功')
              this.loadTree()
            } else {
              this.$message.warning((res && res.message) || '删除失败')
            }
          })
        }
      })
    },
    // ==================== 编辑公式 ====================
    openFormula(record) {
      if (record.is_group === '1') return
      this.formulaItem = record
      this.formulaRows = []
      this.formulaOriginal = []
      this.innerFormulaValue = record.inner_formula || ''
      this.newFormula = { subjectCode: undefined, operator: '+', calcRule: this.calcRules[0] || '' }
      this.formulaVisible = true
      this.loadSubjectOptions()
      this.formulaLoading = true
      reportFormulaList({ itemId: record.id }).then((res) => {
        if (res && res.success && res.data) {
          this.formulaRows = res.data.map((r) => ({
            key: 'f' + r.id,
            id: r.id, subject_code: r.subject_code, operator: r.operator, calc_rule: r.calc_rule, sort: r.sort
          }))
          this.formulaOriginal = this.formulaRows.map((r) => ({ id: r.id, subject_code: r.subject_code, operator: r.operator, calc_rule: r.calc_rule }))
        } else {
          this.$message.warning((res && res.message) || '公式查询失败')
        }
        this.formulaLoading = false
      }).catch(() => { this.formulaLoading = false })
    },
    /** 科目/现金流项目下拉：cashflow=现金流项目（candidates groups），其余=末级科目 */
    loadSubjectOptions() {
      if (this.subjectOptions.length) return
      if (this.routeType === 'cashflow') {
        cashFlowCandidates({ accountSetId: this.accountSetId }).then((res) => {
          if (res && res.success && res.data) {
            const opts = []
            const map = {}
            const seen = {}
            ;(res.data.groups || []).forEach((g) => {
              ;(g.items || []).forEach((it) => {
                const code = it.code == null ? '' : String(it.code)
                if (!code || seen[code]) return
                seen[code] = true
                map[code] = it.name
                opts.push({ code: code, label: code + ' ' + (it.name || '') })
              })
            })
            this.subjectOptions = opts
            this.subjectNameMap = map
          }
        }).catch(() => {})
      } else {
        subjectLeafList({ accountSetId: this.accountSetId }).then((res) => {
          if (res && res.success && res.data) {
            const opts = []
            const map = {}
            ;(res.data || []).forEach((s) => {
              const code = s.subjectCode == null ? '' : String(s.subjectCode)
              if (!code) return
              map[code] = s.subjectName
              opts.push({ code: code, label: code + ' ' + (s.subjectName || '') })
            })
            this.subjectOptions = opts
            this.subjectNameMap = map
          }
        }).catch(() => {})
      }
    },
    filterSubjectOption(input, option) {
      const text = (option.componentOptions.children[0] || {}).text || ''
      return text.toLowerCase().indexOf(input.toLowerCase()) > -1
    },
    subjectDisplay(code, calcRule) {
      if (calcRule === '损益净额合计') return '全部损益科目'
      const name = this.subjectNameMap[code]
      return name ? (code + ' ' + name) : (code || '')
    },
    addFormulaRow() {
      const nf = this.newFormula
      if (!nf.calcRule) { this.$message.warning('缺少取数规则'); return }
      if (nf.calcRule !== '损益净额合计' && !nf.subjectCode) { this.$message.warning('请选择科目'); return }
      const nextSort = this.formulaRows.reduce((mx, r) => Math.max(mx, Number(r.sort || 0)), 0) + 10
      this.formulaNewSeq++
      this.formulaRows.push({
        key: 'n' + this.formulaNewSeq,
        id: null,
        subject_code: nf.calcRule === '损益净额合计' ? 'ALL' : nf.subjectCode,
        operator: nf.operator,
        calc_rule: nf.calcRule,
        sort: nextSort
      })
      nf.subjectCode = undefined
    },
    removeFormulaRow(record) {
      const idx = this.formulaRows.findIndex((r) => r.key === record.key)
      if (idx > -1) this.formulaRows.splice(idx, 1)
    },
    /** 表外公式保存：与打开时快照整表比对，逐条删除/新增/更新 */
    saveFormulas() {
      const itemId = this.formulaItem.id
      const current = this.formulaRows
      const original = this.formulaOriginal
      const tasks = []
      original.forEach((o) => {
        if (!current.some((c) => c.id && c.id === o.id)) tasks.push({ type: 'delete', id: o.id })
      })
      current.forEach((c) => {
        const orig = c.id ? original.find((o) => o.id === c.id) : null
        const payload = { itemId: itemId, subjectCode: c.subject_code, operator: c.operator, calcRule: c.calc_rule, sort: c.sort }
        if (!orig) {
          tasks.push({ type: 'save', payload: payload })
        } else if (orig.subject_code !== c.subject_code || orig.operator !== c.operator || orig.calc_rule !== c.calc_rule) {
          tasks.push({ type: 'save', payload: Object.assign({ id: c.id }, payload) })
        }
      })
      if (!tasks.length) { this.formulaVisible = false; return }
      this.formulaSaving = true
      const run = (i) => {
        if (i >= tasks.length) {
          this.formulaSaving = false
          this.$message.success('公式已保存')
          this.formulaVisible = false
          return
        }
        const t = tasks[i]
        const req = t.type === 'delete' ? reportFormulaDelete({ id: t.id }) : reportFormulaSave(t.payload)
        req.then((res) => {
          if (res && res.success) run(i + 1)
          else {
            this.formulaSaving = false
            this.$message.warning((res && res.message) || '保存失败')
          }
        }).catch(() => { this.formulaSaving = false })
      }
      run(0)
    },
    /** 表内公式保存：整字段回传数据项，仅更新 inner_formula */
    saveInnerFormula() {
      const expr = (this.innerFormulaValue || '').trim()
      if (!/^\d+([+-]\d+)*$/.test(expr)) {
        this.$message.warning('表内公式格式不正确（应为行次加减式，如 1-2-3+5）')
        return
      }
      const it = this.formulaItem
      this.formulaSaving = true
      reportItemSave({
        id: it.id,
        accountSetId: this.accountSetId,
        reportType: this.routeType,
        itemName: it.item_name,
        parentId: it.parentId == null ? null : it.parentId,
        rowNo: it.row_no == null ? null : String(it.row_no),
        isGroup: it.is_group === '1' ? '1' : '0',
        sourceType: 'inner',
        innerFormula: expr,
        category: this.routeType === 'balance' ? (it.category || null) : null,
        bold: it.bold === '1' ? '1' : '0',
        folded: it.folded === '1' ? '1' : '0',
        displayPos: it.display_pos || null,
        sort: it.sort
      }).then((res) => {
        if (res && res.success) {
          this.$message.success('公式已保存')
          this.formulaVisible = false
          this.loadTree()
        } else {
          this.$message.warning((res && res.message) || '保存失败')
        }
        this.formulaSaving = false
      }).catch(() => { this.formulaSaving = false })
    }
  }
}
</script>

<style scoped>
.ri-header { overflow: hidden; margin-bottom: 12px; }
.ri-title { font-size: 16px; font-weight: 600; line-height: 32px; }
.float-right { float: right; }
</style>
